export default function ErrorFrame({message, action, onAction}) {
    return(<div className="error-card standard-padding columns gap-xs">
        <p className="card-title error">{message ?? 'Error fetching data'}</p>
        <button className="solid-error" onClick={onAction}>{action ?? 'Retry'}</button>
    </div>)
}